import { makeStyles } from '@rbx/ui';

const useCommonCodeBlockStyles = makeStyles()((theme) => ({
  codeBlock: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(6),
    '& + pre': {
      marginTop: 0,
    },
  },
}));

export default useCommonCodeBlockStyles;
